import { combineReducers } from "redux";
import order from "./order";

const rootReducer = combineReducers({
  order,
});

export default rootReducer;
